<svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.2339 10.6311L14.7017 20.1633L5.16949 10.6311" stroke="#8148a8" stroke-width="3.1774" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
